// Shared uniform-size card tiles used by "add more items" style sections —
// the admin Analysis workspace's Additional Email / Occurrence-of-Symptoms
// cards (DetailsTab.js) and the patient intake form's equivalent sections
// (AdditionalEmailSection.jsx, TestSymptomsSection.jsx) both use these, so
// the two stay visually in sync instead of drifting apart.
export const cardTileSx = {
  position: "relative",
  height: 92,
  borderRadius: "14px",
  border: "1px solid #e0e0e0",
  bgcolor: "#fff",
  p: 2,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
};

export const cardAddTileSx = {
  ...cardTileSx,
  alignItems: "center",
  justifyContent: "center",
  border: "1px dashed #c7cacd",
  color: "#9AA0A6",
  cursor: "pointer",
  transition: "border-color 0.15s ease, color 0.15s ease, background-color 0.15s ease",
  "&:hover": { borderColor: "#16498A", color: "#16498A", bgcolor: "#FAFBFC" },
};

export const cardRemoveButtonSx = {
  position: "absolute",
  top: 6,
  right: 6,
  width: 22,
  height: 22,
  bgcolor: "#f5f5f5",
  color: "#6b7280",
  "&:hover": { bgcolor: "#fde8e8", color: "#c62828" },
};

export const cardGridSx = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)", md: "repeat(3, 1fr)" },
  gap: 2,
};
